<template>
  <div v-if="toggletableview === 0">
    <div v-if="filteredcommentarydata.length > 0">
      <v-simple-table dense class="main-table-style">
        <template v-slot:default>
          <thead class="tableHeaderBg">
            <tr>
              <th rowspan="2" class="align-center ">Navigation <v-tooltip bottom content-class="tooltip-bottom">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="toggleExpandAll" class="ml-2" data-testid="ru-table-view__expand-collapse-all-btn">
                      {{ isAllExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}
                    </v-icon>
                  </template>
                  <span>{{ isAllExpanded ? 'Collapse All' : 'Expand All' }}</span>
                </v-tooltip>
              </th>
              <th class="" scope="multiselect" rowspan='2' v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3"></th>
              <th class="" scope="rucode" v-if="toggleview === 3" rowspan="2">{{$nova.labelsName('cycle_page','commentary_ru_code_label','RU Code')  }}</th>
              <th class="" scope="runame" v-if="toggleview === 3" rowspan="2">{{ $nova.labelsName('cycle_page','ru_name','RU Name')  }}</th>
              <th scope="type" class="" rowspan="2">
                {{ $nova.labelsName('cycle_page', 'commentary_gl_code_label', 'GL Code')  }}
                <!-- <br /> -->
                <v-btn class="shadow-off ml-2" name="filter-gl-code" icon @click="customfiltersdialog = true" data-testid="ru-table-view__filter-btn">
                  <v-icon>mdi-filter-menu</v-icon>
                </v-btn>
              </th>
              <th scope="description" rowspan="2">Description</th>
              <th scope="amount1heading" rowspan="2" class="text-right ">{{ (cycletype === 'Forecast') ? $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast') : $nova.labelsName('cycle_page','actual_label','Actual')}}</th>
              <th scope="type" class="text-center  " colspan="3">{{ (cycletype === 'Forecast') ? $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast') : $nova.labelsName('cycle_page','actual_label','Actual')}} Vs {{ $nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') }}</th>
              <th scope="type" class="text-center " colspan="3"> {{ (cycletype === 'Forecast') ? $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast') : $nova.labelsName('cycle_page','actual_label','Actual')}} Vs {{ (cycletype === 'Forecast') ? 'Previous Forecast': $nova.labelsName('cycle_page','forecast_shortform_label','Forecast') }} </th>
              <th scope="variancepercent" class="text-center " rowspan="2">{{ $nova.labelsName('cycle_page','commentary_action_label','Action') }}</th>
              <th scope="status" class="text-center " rowspan="2"> Status <br />
                <v-btn icon @click="statushelpdialog = true" data-testid="ru-table-view__status-help-btn">
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
              </th>
            </tr>
            <tr class="selected-header-row">
              <th scope="amount2heading" class="text-right">
                {{ $nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') }}
              </th>
              <th scope="varianceamt" class="text-right ">{{ $nova.labelsName('cycle_page','commentary_variance_amount_label','Variance Amt')  }} </th>
              <th scope="variancepercent" class="text-right ">{{ $nova.labelsName('cycle_page','commentary_variance_label','Variance')  }} % </th>
              <!-- <th scope="variancepercent" class="">{{ $nova.labelsName('cycle_page', 'commentary_local_label',' Local Commentary') }}</th> -->
              <th scope="amount2heading" class="text-right ">
                {{ (cycletype === 'Forecast') ? 'Previous Forecast':$nova.labelsName('cycle_page','forecast_shortform_label','Forecast')}}
              </th>
              <th scope="varianceamt" class="text-right ">{{ $nova.labelsName('cycle_page','commentary_variance_amount_label','Variance Amt')  }}</th>
              <th scope="variancepercent" class="text-right ">{{ $nova.labelsName('cycle_page','commentary_variance_label','Variance')  }} %</th>
              <!-- <th scope="variancepercent" class="">{{ $nova.labelsName('cycle_page', 'commentary_local_label',' Local Commentary') }}</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="v in pagedItems" 
            :key="v._id" class="tree-table cursor-pointer" 
            v-intersect.quiet="getIntersectHandler(v)">
              <template v-if="v.__code === 'NA'">
                <td @click.stop="toggleExpand(v)">
                  <div class="tree-label d-flex align-center " :class="`padding-level-${v.level}`">
                    <div class="node-container">
                      <span class="node-label childlevele"></span>
                    </div>
                    <div>
                      <span v-if="hasChildren(v) && !isFilterSet"  class="expand-icon">
                        <v-icon data-testid="ru-table-view__na-expand-icon">
                          {{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}
                        </v-icon>
                      </span>
                      <span v-else class="no-children-spacer"></span>
                    </div>
                  </div>
                </td>
                <td class="pl-2 pr-0" v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3">
                </td>
                <td>NA</td>
                <td class="description-cell" colspan="12">
                  {{ v.glcode_detail.name }}
                  <v-tooltip bottom content-class="tooltip-bottom" v-if="cycletype === 'Actual' && (v.__code === '410000' || v.__code === '13900')">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon class="ml-2" target="_blank" @click.stop="getNetSalesData(v)" data-testid="ru-table-view__na-netsales-breakup-btn">
                        <v-icon>mdi-format-list-bulleted</v-icon>
                      </v-btn>
                    </template>
                    <span>Breakup</span>
                  </v-tooltip>
                  <v-tooltip bottom content-class="tooltip-bottom" v-if="cycletype === 'Actual' && (v.__code === '450000' || v.__code === '10900')">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon class="ml-2" target="_blank" @click.stop="getRevenueData(v)" data-testid="ru-table-view__na-revenue-breakup-btn">
                        <v-icon>mdi-format-list-bulleted</v-icon>
                      </v-btn>
                    </template>
                    <span>Breakup</span>
                  </v-tooltip>
                </td>
              </template>
              <template v-else>
                <td @click.stop="toggleExpand(v)">
                  <div class="tree-label d-flex align-center" :class="`padding-level-${v.level}`">
                    <div class="node-container">
                      <span class="node-label childlevele"></span>
                    </div>
                    <div>
                      <span v-if="hasChildren(v) && !isFilterSet" class="expand-icon">
                        <v-icon data-testid="ru-table-view__gl-expand-icon">
                          {{ isExpanded(v) ? "mdi-minus-box" : "mdi-plus-box" }}
                        </v-icon>
                      </span>
                      <span v-else class="no-children-spacer"></span>
                    </div>
                  </div>
                </td>
                <td class="pl-0 pr-0" @click.stop="hasChildren(v)" v-if="(ispreparer || isapprover || isregionalapprover) && toggleview !== 3">
                  <v-checkbox multiple v-model="multiselectdata" :value="v._id" name="select-gl-code" hide-details dense class="pa-0 ma-0 navigation-checkbox-cycle" :data-test="v.__type === 'header' ? 'parent-checkbox' : 'child-checkbox'"></v-checkbox>
                </td>
                <td v-if="toggleview === 3">{{commentarycycledatalist[v.cycle]?.reportingunit_detail?.code}}</td>
                <td v-if="toggleview === 3">{{commentarycycledatalist[v.cycle]?.reportingunit_detail?.name}}</td>
                <td>
                  {{ v.glcode_detail.code }}
                </td>
                <!-- Description -->
                <td class="description-cell">
                  {{ v.glcode_detail.name }}
                  <v-tooltip bottom content-class="tooltip-bottom" v-if="cycletype === 'Actual' && (v.__code === '410000' || v.__code === '13900')">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon class="ml-2" target="_blank" @click.stop="getNetSalesData(v)" data-testid="ru-table-view__gl-netsales-breakup-btn">
                        <v-icon>mdi-format-list-bulleted</v-icon>
                      </v-btn>
                    </template>
                    <span>Breakup</span>
                  </v-tooltip>
                  <v-tooltip bottom content-class="tooltip-bottom" v-if="cycletype === 'Actual' && (v.__code === '450000' || v.__code === '10900')">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon class="ml-2" target="_blank" @click.stop="getRevenueData(v)" data-testid="ru-table-view__gl-revenue-breakup-btn">
                        <v-icon>mdi-format-list-bulleted</v-icon>
                      </v-btn>
                    </template>
                    <span>Breakup</span>
                  </v-tooltip>
                </td>
                <td class="text-right">
                  {{ $nova.formatCurrency(v.amount1.toFixed(1), '', false, true) }}
                </td>
                <td class="text-right">
                  {{ $nova.formatCurrency(v.amount2.toFixed(1), '', false, true) }}
                </td>
                <td class="" @click.stop="toggleExpand(v)">
                  <div class="d-flex align-center">
                    <div class="d-flex flex-column">
                      <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="l_c_m_c_pro" data-testid="ru-table-view__proforma-control-flag">mdi-circle</v-icon>
                        </template>
                        <span>{{ (local_controls_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                      <v-spacer></v-spacer>
                      <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="l_m_m_c_pro" data-testid="ru-table-view__proforma-mgmt-flag">mdi-circle</v-icon>
                        </template>
                        <span>{{ (local_management_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                    </div>
                    <div class="d-flex flex-column">
                      <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_control_regional">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="r_c_m_c_pro" data-testid="ru-table-view__proforma-regional-control-flag">mdi-record-circle-outline</v-icon>
                        </template>
                        <span>{{ (regional_controls_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                      <v-spacer></v-spacer>
                      <v-tooltip left content-class="tooltip-left" v-if="v.var1_cross_management_regional">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="r_m_m_c_pro" data-testid="ru-table-view__proforma-regional-mgmt-flag">mdi-record-circle-outline</v-icon>
                        </template>
                        <span>{{ (regional_management_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                    </div>
                    <v-spacer></v-spacer>
                    <div :class="['ml-2', v.varianceamount1 > 0 ? 'success--text' : v.varianceamount1 < 0 ? 'error--text' : '']" @click.stop="hasChildren(v)">
                      <span>{{$nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true)}}</span>
                  </div>
                  </div>
                </td>
                <td :class="`${(v.varianceamount1 > 0) ? 'success--text' : (( v.varianceamount1 < 0 ) ? 'error--text' : '')} text-right`" @click.stop="hasChildren(v)">
                  <span>{{ $nova.formatCurrency((v.variancepercent1).toFixed(1), '', false,true)}}{{ ((v.variancepercent1 !== 0)?'%':'')}}</span>
                </td>
                <!-- <td class="jv_commentary">
                  <span v-if="isJVCommentary1Valid(v)">
                    <v-chip small density="comfortable">JV:</v-chip>
                    {{Object.entries(v.jv_commentary1).map(([key, value]) => `${key}: ${value}`).join(', ')}} 
                  </span>
                  <span v-else-if="!v.ignorecommentary">{{ v.commentary1 }}</span>
                </td> -->
                <td class="text-right">
                  {{ $nova.formatCurrency(v.amount3.toFixed(1), '', false, true) }}
                </td>
                <td @click.stop="toggleExpand(v)">
                  <div class="d-flex align-center mr-1">
                    <div class="d-flex flex-column">
                      <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="l_c_m_c_fore" data-testid="ru-table-view__forecast-control-flag">mdi-circle</v-icon>
                        </template>
                          <span>{{ (local_controls_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                      <v-spacer />
                      <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="l_m_m_c_fore" data-testid="ru-table-view__forecast-mgmt-flag">mdi-circle</v-icon>
                        </template>
                          <span>{{ (local_management_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                    </div>
                    <div class="d-flex flex-column">
                      <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_control_regional">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="error--text controls_flag" id="r_c_m_c_fore" data-testid="ru-table-view__forecast-regional-control-flag">mdi-record-circle-outline</v-icon>
                        </template>
                          <span>{{ (regional_controls_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                      <v-spacer />
                      <v-tooltip left content-class="tooltip-left" v-if="v.var2_cross_management_regional">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  class="blue--text controls_flag" id="r_m_m_c_fore" data-testid="ru-table-view__forecast-regional-mgmt-flag">mdi-record-circle-outline</v-icon>
                        </template>
                          <span>{{ (regional_management_label + ' Materiality crossed')  }}</span>
                      </v-tooltip>
                    </div>
                    <v-spacer></v-spacer>
                    <div :class="['ml-2', v.varianceamount2 > 0 ? 'success--text' : v.varianceamount2 < 0 ? 'error--text' : '']" @click.stop="hasChildren(v)">
                      <span>{{$nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true)}}</span>
                  </div>
                  </div>
                </td>
                <td :class="`${(v.varianceamount2 > 0) ? 'success--text' : ((v.varianceamount2 < 0) ? 'error--text' : '')} text-right`" @click.stop="hasChildren(v)">
                  <span>{{ $nova.formatCurrency((v.variancepercent2).toFixed(1), '', false, true)}}{{ ((v.variancepercent2 !== 0)?'%':'')}}</span>
                </td>
                <!-- <td class="jv_commentary">
                  <span v-if="isJVCommentary2Valid(v)">
                    <v-chip small density="comfortable">JV:</v-chip>
                    {{Object.entries(v.jv_commentary2).map(([key, value]) => `${key}: ${value}`).join(', ')}}
                  </span>
                  <span v-else-if="!v.ignorecommentary">{{ v.commentary2 }}</span>
                </td> -->
                <td>
                  <div class="d-flex justify-center">
                    <v-tooltip v-if="(isapprover) && [3,4,7,8,9].indexOf(v.__stage) > -1 && (ispendinglocalruapproval || (!ispendinglocalruapproval && !workflows.isregionalenabled))" bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click.stop="openSubmitDialog(v, 'requestlocal')" v-bind="attrs" v-on="on" name="request-commentary-local" icon :disabled="!workflows.islocalenabled" data-testid="ru-table-view__request-local-btn">
                          <v-icon>mdi-comment-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>{{'Request Commentary' }}</span>
                    </v-tooltip>
                    <v-tooltip v-if="(isregionalapprover) && [3,4,7,8,9].indexOf(v.__stage) > -1" bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click.stop="openSubmitDialog(v, 'requestregional')" v-bind="attrs" v-on="on" name="request-commentary-regional" icon :disabled="!workflows.isregionalenabled" data-testid="ru-table-view__request-regional-btn">
                          <v-icon>mdi-comment-plus-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{'Request Commentary' }}</span>
                    </v-tooltip>
                    <v-tooltip v-if="(v.__myaction === 'localadd' || (v.__myaction === 'localvoluntary' && (ispendinglocalruapproval || ispendingregionalruapproval))) && v.__stage !== 9" bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click.stop="openSubmitDialog(v, 'addlocal')" v-bind="attrs" v-on="on" name="add-local-commentary" icon :disabled="!workflows.islocalenabled" data-testid="ru-table-view__add-local-btn">
                          <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>{{'Add ' + commentary_local_key_label + ' Commentary' }}</span>
                    </v-tooltip>
                    <v-tooltip v-if="(v.__myaction === 'regionaladd') && v.__stage !== 9" bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click.stop="openSubmitDialog(v, 'addregional')" v-bind="attrs" v-on="on" name="add-regional-commentary" icon :disabled="!workflows.isregionalenabled" data-testid="ru-table-view__add-regional-btn">
                          <v-icon>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{'Add ' + commentary_regional_key_label + ' Commentary' }}</span>
                    </v-tooltip>
                    <v-tooltip v-if="v.__myaction === 'localapprove'" bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click.stop="openSubmitDialog(v, 'approvelocal',true)" color="" v-bind="attrs" name="approve-local-commmentary" v-on="on" icon data-testid="ru-table-view__approve-local-btn">
                          <v-icon>mdi-check-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>{{commentary_local_key_label + ' Approve/Reject' }}</span>
                    </v-tooltip>
                    <v-tooltip v-if="((v.__myaction === 'regionalapprove' || (toggleview === 3 && v.stage_regional !== 2)))" bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click.stop="openSubmitDialog(v, 'approveregional')" color="" v-bind="attrs" v-on="on" name="approve-regional-commentary" icon data-testid="ru-table-view__approve-regional-btn">
                          <v-icon>mdi-check-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{commentary_regional_key_label + ' Approve/Reject' }}</span>
                    </v-tooltip>
                    <v-tooltip bottom content-class="tooltip-bottom" v-if="v.__myaction === 'view' || v.__myaction === 'localrequest' || v.__myaction === 'regionalrequest'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="openSubmitDialog(v, 'view', false)" v-bind="attrs" v-on="on" name="view-commentary" icon data-testid="ru-table-view__view-details-btn">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{'View Details' }}</span>
                    </v-tooltip>
                    <div v-if="workflowtext.length !== 8">
                      <lb-conversation heading="Conversation" width="600" :recurring="false" :recurringText="''" :closed="cyclestage === 1 || isviewonly" @markread="v.conversation_read = true" :highlight="!v.conversation_read" :notify="!v.conversation_read" :getapi="'/v3/varianceanalysis/analysis/getconversation/'+v.cycle+'/c/'+v._id" :sendapi="'/v3/varianceanalysis/analysis/addconversation/'+v.cycle+'/c/'+v._id" :readapi="'/v3/varianceanalysis/analysis/markreadconversation/'+v.cycle+'/c/'+v._id" :showprofile="false" />
                    </div>
                    <div v-else>
                      <v-tooltip bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="" name="conversations" v-bind="attrs" v-on="on" icon data-testid="ru-table-view__conversations-btn">
                            <v-icon class="">mdi-comment-text-multiple</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ workflowsDisabledMessage }}</span>
                      </v-tooltip>
                    </div>
                    <lb-activitylog :config="activitylogconfiggl" :url="`/v2/varianceanalysis/analysis/getlogs/${v._id}/f/${(toggleview === 3)?(commentarycycledatalist[v.cycle]?.type):commentarycycledata.type}`" />
                  </div>
                </td>
                <td class="text-center" v-if="!v.ignorecommentary">
                  <v-tooltip left content-class="tooltip-left" v-if="v.__stage === -1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-local-rejected" color="error">mdi-close-circle</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaiting_approval','Local Commentary rejected')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-local-awaited" color="info">mdi-timer-sand-full</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited', 'Local Commentary awaited')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-local-awaited-approval" color="warning">mdi-timer-sand-full</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaiting_approval', 'Local Commentary awaiting approval')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 5">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-regional-awaited" color="info">mdi-timer-sand-empty</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_awaited','Regional Commentary awaited')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-if="v.__stage === -2">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-regional-rejected" color="error">mdi-close-circle-outline</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_rejected','Regional Commentary rejected')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 6">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-regional-awaited-approval" color="warning">mdi-timer-sand-empty</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_regional_commentary_awaiting_approval', 'Regional Commentary awaiting approval')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 7">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-approved-commentary" color="success">mdi-check-circle</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_approved_label', 'Approved Commentary')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 3">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-nil-value" color="grey">mdi-bookmark-off</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_nil_value_accounts_label', 'Nil value accounts')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 4">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-immaterial" color="grey">mdi-cash-remove</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page','commentary_filter_immaterial_variance_label','Immaterial variance')  }}</span>
                  </v-tooltip>
                  <v-tooltip left content-class="tooltip-left" v-else-if="v.__stage === 9">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" name="status-not-in-scope" color="grey">mdi-forum-remove-outline</v-icon>
                    </template>
                    <span>{{ $nova.labelsName('cycle_page', 'commentary_filter_not_in_scope_label', 'Not in Scope')  }}</span>
                  </v-tooltip>
                </td>
                <td v-else></td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div v-else-if="filteredcommentarydata && filteredcommentarydata.length === 0 && !isReportingUnitClicked"
      class="title grey--text pa-5 text-center">{{ ('No data found')  }}</div>
  </div>
</template>

<script>
export default {
  name: 'RUTableView',
  
  props: {
    toggletableview: { type: Number, default: 0 },
    filteredcommentarydata: { type: Array, default: () => [] },
    pagedItems: { type: Array, default: () => [] },
    tablecolors: { type: Object, default: () => ({ heading: { a: '', b: '' }, body: { a: '', b: '' } }) },
    cycletype: { type: String, default: '' },
    toggleview: { type: Number, default: 0 },
    commentarycycledatalist: { type: Object, default: () => ({}) },
    commentarycycledata: { type: Object, default: () => ({}) },
    ispreparer: { type: Boolean, default: false },
    isapprover: { type: Boolean, default: false },
    isregionalapprover: { type: Boolean, default: false },
    multiselectdata: { type: Array, default: () => [] },
    commentaryLocalKeyLabel: { type: String, default: 'Local' },
    commentaryRegionalKeyLabel: { type: String, default: 'Regional' },
    workflowsDisabledMessage: { type: String, default: '' },
    workflows: { type: Object, default: () => ({ islocalenabled: false, isregionalenabled: false }) },
    workflowtext: { type: [Array, String], default: () => [] },
    cyclestage: { type: Number, default: 0 },
    activitylogconfiggl: { type: Object, default: () => ({}) },
    localControlsLabel: { type: String, default: 'Local Controls' },
    localManagementLabel: { type: String, default: 'Local Management' },
    regionalControlsLabel: { type: String, default: 'Regional Controls' },
    regionalManagementLabel: { type: String, default: 'Regional Management' },
    isviewonly: { type: Boolean, default: false },
    isReportingUnitClicked: { type: Boolean, default: false },
    isFilterSet: { type: Boolean, default: false },
    isAllExpanded: { type: Boolean, default: false },
    ispendinglocalruapproval: { type: Boolean, default: false },
    ispendingregionalruapproval: { type: Boolean, default: false },
    
    // Function props
    toggleExpandAllFn: { type: Function, required: true },
    toggleExpandFn: { type: Function, required: true },
    hasChildrenFn: { type: Function, required: true },
    isExpandedFn: { type: Function, required: true },
    handleIntersectFn: { type: Function, required: true },
    getNetSalesDataFn: { type: Function, required: true },
    getRevenueDataFn: { type: Function, required: true },
    openSubmitDialogFn: { type: Function, required: true },
    isActualJVCommentaryValidForLocalFn: { type: Function, required: true },
    isForecastJVCommentaryValidForLocalFn: { type: Function, required: true },
    isForecastJVCommentaryValidForRegionalFn: { type: Function, required: true },
    regionalCommentary2CountFn: { type: Function, required: true },
    commentaryChartFn: { type: Function, required: true },
  },
  
  computed: {
    // Map kebab-case props to camelCase for easier access in template
    commentary_local_key_label() {
      return this.commentaryLocalKeyLabel;
    },
    commentary_regional_key_label() {
      return this.commentaryRegionalKeyLabel;
    },
    local_controls_label() {
      return this.localControlsLabel;
    },
    local_management_label() {
      return this.localManagementLabel;
    },
    regional_controls_label() {
      return this.regionalControlsLabel;
    },
    regional_management_label() {
      return this.regionalManagementLabel;
    },
  },
  
  methods: {
    // Wrapper methods that call the function props
    toggleExpandAll() {
      if (this.toggleExpandAllFn) {
        this.toggleExpandAllFn();
      }
    },
    
    toggleExpand(item) {
      if (this.toggleExpandFn) {
        this.toggleExpandFn(item);
      }
    },
    
    hasChildren(item) {
      if (this.hasChildrenFn) {
        return this.hasChildrenFn(item);
      }
      return false;
    },
    
    isExpanded(item) {
      if (this.isExpandedFn) {
        return this.isExpandedFn(item);
      }
      return false;
    },
    
    getIntersectHandler(item) {
      return (entries) => {
        if (entries[0]?.isIntersecting && this.handleIntersectFn) {
          this.handleIntersectFn(item.__index);
        }
      };
    },
    
    onGetNetSalesData(item) {
      if (this.getNetSalesDataFn) {
        this.getNetSalesDataFn(item);
      }
    },
    
    onGetRevenueData(item) {
      if (this.getRevenueDataFn) {
        this.getRevenueDataFn(item);
      }
    },
    
    isActualJVCommentaryValidForLocal(item) {
      if (this.isActualJVCommentaryValidForLocalFn) {
        return this.isActualJVCommentaryValidForLocalFn(item);
      }
      return false;
    },
    
    isForecastJVCommentaryValidForLocal(item) {
      if (this.isForecastJVCommentaryValidForLocalFn) {
        return this.isForecastJVCommentaryValidForLocalFn(item);
      }
      return false;
    },
    
    isForecastJVCommentaryValidForRegional(item) {
      if (this.isForecastJVCommentaryValidForRegionalFn) {
        return this.isForecastJVCommentaryValidForRegionalFn(item);
      }
      return false;
    },
    
    regionalCommentary2Count(item) {
      if (this.regionalCommentary2CountFn) {
        return this.regionalCommentary2CountFn(item);
      }
      return 0;
    },
    
    commentaryChart(comment, reason) {
      if (this.commentaryChartFn) {
        return this.commentaryChartFn(comment, reason);
      }
      return { comment, reason };
    },
    
    onOpenSubmitDialog(item, action, isLocal = false) {
      if (this.openSubmitDialogFn) {
        this.openSubmitDialogFn(item, action, isLocal);
      }
    },
  },
};
</script>

<style scoped>
.main-table-style {
  /* Table styling */
}

.tree-label {
  cursor: pointer;
  user-select: none;
}

.node-container {
  width: 20px;
  height: 20px;
  display: inline-block;
}

.expand-icon {
  margin-left: 4px;
}

.no-children-spacer {
  display: inline-block;
  width: 28px;
}

.description-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis-on {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tree-table {
  transition: background-color 0.2s;
}

.tree-table:hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* Child level indicators */
.childlevele::before {
  content: '';
  display: inline-block;
  width: 0;
}

.padding-level-0 {
  padding-left: 0px;
}

.padding-level-1 {
  padding-left: 10px;
}

.padding-level-2 {
  padding-left: 20px;
}

.padding-level-3 {
  padding-left: 30px;
}

.padding-level-4 {
  padding-left: 40px;
}

/* New class for header row */
.selected-header-row th {
  /* Styling for second header row if needed */
}

/* Controls flag styling */
.controls_flag {
  font-size: 7px !important;
  margin: 1px 1px !important;
}
</style>
